<template>
  <div class="user-center" no-body>
    <tabsLayout>
      <b-tabs
        card
        lazy
        content-class="my-0"
        active-nav-item-class="font-weight-bold"
      >
        <b-tab
          v-for="tab of tabs"
          :key="tab.key"
          :title="tab.label"
          @click="$router.push({ name: tab.componentName })"
          class="px-0"
        >
        </b-tab>
      </b-tabs>
      <div class="form-layout">
        <router-view></router-view>
      </div>
    </tabsLayout>
  </div>
</template>

<script>
import tabsLayout from "@/layout/TabsLayout.vue";
export default {
  components: {
    tabsLayout
  },
  computed: {
    tabs() {
      return [
        {
          key: "userInfo",
          label: "個人資料",
          componentName: "userInfo"
        },
        {
          key: "userPassword",
          label: "修改密碼",
          componentName: "userPassword"
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.user-center {
  .form-layout {
    margin-left: 100px;
    margin-right: 100px;
    max-width: 300px;
  }
}
</style>
